(ns frontend.ui.component.alert.view
  (:require
   [frontend.ui.component.alert.style :as style]
   [frontend.ui.component.icon.view :refer [icon]]
   [herb.core :refer [<class]]))

(defn alert
  "`variant` must be one of `:info`, `:success`, `:warning` or `:danger`"
  [{:keys [variant]} child]
  [:div
   {:class (<class style/alert variant)}
   [icon
    {:variant :solid
     :class   (<class style/icon variant)}
    (condp = variant
      :info :info-circle
      :success :check-circle
      :warning :exclamation-circle
      :danger :times-circle)]
   [:div
    {:class (<class style/child)}
    child]])
